module.exports = __webpack_public_path__ + "static/media/phone.53b4c09c.svg";